import React, { SyntheticEvent, useCallback, useMemo } from 'react';

import ChatTabsView from './ChatTabsView';

import { useChatState } from '../../../../../hooks/context';

import { IChatTabs } from './interfaces';
import { ChatTabs as ChatTabsEnum } from '../../../../../interfaces/channel';
import { useMytaverse } from '../../../../../providers/MytaverseProvider';
import { IXRHrPersonaTypes } from '../../../../../interfaces/profile';
import { useMytaverseEvent } from '../../../providers';
import { env } from '../../../../../env';

const { REACT_APP_SHOW_PRIVATE_CHAT } = env;
const REACT_APP_MULTI_PLAYER_TAG =
  env.REACT_APP_MULTI_PLAYER_TAG || 'MultiPlayer';

const ChatTabs = ({ sx = {} }: IChatTabs) => {
  const {
    activeTab,
    setActiveTab,
    isUnreadEventChannel,
    isUnreadPrivateChannel,
  } = useChatState();
  const { currentEvent } = useMytaverseEvent();
  const { user } = useMytaverse();

  const handleChangeTab = useCallback(
    (_: SyntheticEvent, value: ChatTabsEnum) => {
      setActiveTab(value);
    },
    [],
  );

  const isPrivateChatEnabled = useMemo(() => {
    const isOfficeHours =
      currentEvent?.eventTags &&
      currentEvent?.eventTags.indexOf('OfficeHours') > -1;
    const isHRFacilitator =
      user?.hrData?.persona?.toUpperCase() === IXRHrPersonaTypes.HR_Facilitator;

    return !isOfficeHours || (isOfficeHours && isHRFacilitator);
  }, [user, currentEvent]);

  const hasMultiPlayerTag = useMemo(() => {
    return (
      currentEvent?.eventTags &&
      Array.isArray(currentEvent.eventTags) &&
      currentEvent.eventTags.includes(REACT_APP_MULTI_PLAYER_TAG)
    );
  }, [currentEvent?.eventTags]);

  return (
    <ChatTabsView
      sx={sx}
      activeTab={activeTab}
      onChangeTab={handleChangeTab}
      isUnreadEventChannel={isUnreadEventChannel}
      isUnreadPrivateChannel={isUnreadPrivateChannel}
      isPrivateChatEnabled={
        REACT_APP_SHOW_PRIVATE_CHAT === 'true' ||
        (isPrivateChatEnabled && hasMultiPlayerTag)
      }
    />
  );
};

export default ChatTabs;
